import { useQuery } from "@tanstack/react-query";
import { TransactionCodesApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";
import { useAccessToken, useTenantData } from "@/hooks";
import { sortTransactionCodesBySortOrder } from "@/features/transaction-codes/utils/transaction-code-sort";

export const useTransactionCodesGet = (enabled = true) => {
  const accessToken = useAccessToken();
  const { tenantId } = useTenantData();

  const { data, isError, isLoading, isPending, refetch } = useQuery({
    queryKey: [QueryKeys.TransactionCodes],
    queryFn: async () => {
      if (!accessToken) throw new Error("Authentication token is required");
      const service = createAuthenticatedApi(TransactionCodesApi, accessToken);
      const items = await service.apiTransactionCodesGet({ xTenantID: tenantId });
      return sortTransactionCodesBySortOrder(items);
    },
    enabled: enabled !== false && !!accessToken,
    staleTime: 5 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  return { data, isError, isLoading, isPending, refetch };
};
